import { styled } from '@linaria/react'
import { useTranslation } from 'react-i18next'

import { useBoundStore } from '../../store/store'
import Icon from '../icon'

const Container = styled.button`
  width: 180px;
  height: 40px;
  display: block;
  margin: 30px auto 0;
  background-color: var(--secondary);
  border-radius: 25px;
  position: relative;
  padding: 5px;
  transition: all 0.2s ease-in-out;
  @media (min-width: 1200px) {
    margin: 25px 0 0 15px;
  }
`

const Tab = styled.div`
  width: 50%;
  position: absolute;
  top: 5px;
  line-height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 400;
  z-index: 1;
  color: #888;
  border-radius: 25px;
  transition: all 0.2s ease-in-out;
  svg {
    margin-right: 7px;
    fill: #888;
    transition: all 0.2s ease-in-out;
  }
  &.active {
    color: var(--txt);
    svg {
      fill: var(--txt);
    }
  }
`

const ActiveOverlay = styled.div`
  position: absolute;
  width: 50%;
  top: 5px;
  height: 30px;
  border-radius: 25px;
  transition: all 0.2s ease-in-out;
  .theme-dark & {
    left: 5px;
    background-color: #18191a;
  }
  .theme-light & {
    left: calc(50%);
    background-color: #eaecf3;
  }
`

const ThemeSwitch = () => {
  const theme = useBoundStore(state => state.common.theme)
  const setTheme = useBoundStore(state => state.common.setTheme)
  const { t } = useTranslation('common')

  return (
    <Container
      onClick={() => {
        if (theme === 'light') {
          setTheme('dark')
          localStorage.setItem('theme', 'dark')
          document.body.classList.remove('theme-light')
          !document.body.classList.contains('theme-dark') &&
            document.body.classList.add('theme-dark')
        } else {
          setTheme('light')
          localStorage.setItem('theme', 'light')
          document.body.classList.remove('theme-dark')
          !document.body.classList.contains('theme-light') &&
            document.body.classList.add('theme-light')
        }
      }}>
      <ActiveOverlay />
      <Tab style={{ left: 5 }} className={theme === 'dark' ? 'active' : ''}>
        <Icon id="moon" width="16" height="17" />
        {t('dark')}
      </Tab>
      <Tab style={{ right: 5 }} className={theme === 'light' ? 'active' : ''}>
        <Icon id="sun" width="17" height="17" />
        {t('light')}
      </Tab>
    </Container>
  )
}

export default ThemeSwitch
